document.addEventListener('turbo:before-stream-render', (event) => {
  const target = document.getElementById(event.detail.newStream.target);

  if (event.detail.newStream.action === 'prepend') scrollToNewComment(target);
  if (event.detail.newStream.action === 'append') scrollToNewComment(target, true);
});

const scrollToNewComment = (target, subcomment = false) => {
  const scrollSettings = { block: 'start', behavior: 'smooth' };

  // Options for the observer (which mutations to observe)
  const config = { attributes: false, childList: true, subtree: false };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        const target = subcomment ? mutation.target.lastElementChild : mutation.target;
        target.scrollIntoView(scrollSettings);
        observer.disconnect();
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(target, config);
};
